import { FC } from 'react';

import style from './Criteria.css';

interface ICriteriaTabsProps {
  activeIndex: number;
  onTabChange(index: number): void;
}

const TABS = [
  { label: 'Собственнику' },
  { label: 'Агентству или УК', subtitle: '(посуточно)' },
  { label: 'Агентству или УК', subtitle: '(посуточно и вторично)' },
];

export const CriteriaTabs: FC<ICriteriaTabsProps> = ({ activeIndex, onTabChange }) => {
  return (
    <div className={style['tabs']}>
      <div className={style['tabs-row']}>
        {TABS.map((tab, index) => {
          const isActive = index === activeIndex;

          return (
            <button key={index} className={style['tab']} onClick={() => onTabChange(index)}>
              <span className={isActive ? style['tab-number--active'] : style['tab-number']}>{index + 1}</span>
              <div className={isActive ? style['tab-label--active'] : style['tab-label']}>
                {tab.label}
                {tab.subtitle && <span className={style['tab-subtitle']}>{tab.subtitle}</span>}
              </div>
              <div className={isActive ? style['tab-mark--active'] : style['tab-mark']} />
            </button>
          );
        })}
      </div>
      <span className={style['tab-active-label']}>
        {TABS[activeIndex].label}
        {TABS[activeIndex].subtitle && ` ${TABS[activeIndex].subtitle}`}
      </span>
    </div>
  );
};
